// src/routes/PageRender.jsx

import BlogLanding from "../../pages/BlogPage/page/BlogLanding";
import Contact from "../../pages/ContactPage/page/Contact";
import Destination from "../../pages/DestinationPage/page/Destination";
import Event from "../../pages/EventPage/page/Event";
import GeneralPage from "../../pages/GeneralPage/Page/generalPage";
import TestPreparation from "../../pages/TestPreparationPage/page/TestPreparation";

const PAGE_TYPE_COMPONENT = {
  "test-preparation": TestPreparation,
  blog: BlogLanding,
  events: Event,
  contact: Contact,
  services: Destination,
  // "knowledge-and-compliance": GeneralPage,
};

const PageRenderer = ({ pageData }) => {
  console.log("Resolved page:", pageData);

  const Component = PAGE_TYPE_COMPONENT[pageData.slug] || GeneralPage;

  return <Component pageData={pageData} />;
};

export default PageRenderer;
